import { theme, Typography, UnorderedList } from '@fe-toolkit/web-components/ssr'

const CancelOrderModalContent = () => {
  return (
    <div style={{ [theme.breakpoints.down('medium')]: { padding: '0 0 100px 0' } }}>
      <UnorderedList>
        <Typography
          as={'li'}
          sx={{ marginBottom: `${theme.spacing.medium} !important`, paddingRight: theme.spacing.small }}
          variant="speak"
        >
          You'll need to chat with an agent to cancel your order.
        </Typography>
        <Typography
          as={'li'}
          sx={{ marginBottom: `${theme.spacing.medium} !important`, paddingRight: theme.spacing.small }}
          variant="speak"
        >
          The cancellation request will be processed and we'll let you know if it's been rejected or cancelled
          successfully.
        </Typography>
        <Typography
          as={'li'}
          sx={{ marginBottom: `${theme.spacing.medium} !important`, paddingRight: theme.spacing.small }}
          variant="speak"
        >
          If successful, your upcoming installations will be cancelled.
        </Typography>
        <Typography
          as={'li'}
          sx={{ marginBottom: `${theme.spacing.medium} !important`, paddingRight: theme.spacing.small }}
          variant="speak"
        >
          Bear in mind, once the order has been cancelled you won't be able to re-open it.
        </Typography>
      </UnorderedList>
    </div>
  )
}

export default CancelOrderModalContent
